/**
 * IRSP Submissions Vuex State
 * 
 * Stores the list of IRSP submissions and pagination information
 */
export default {
  // List of IRSP submissions
  submissions: [],
  
  // Pagination state matching API response structure
  pagination: {
    currentPage: 1,
    totalPage: 0,
    pageTotal: 0,
    totalItem: 0,
    limit: 25,
    offset: 0,
  },
  
  // Loading states for UI feedback
  isLoading: false,
  isRefreshing: false,
  
  // Error state
  error: null,
}
